export default function FaqItem({ item, index, isOpen, onToggle }) {
  return (
    <div
      className={`overflow-hidden rounded-2xl border transition-colors duration-300 ${
        isOpen ? 'border-secondary/40 bg-white shadow-md shadow-primary/5' : 'border-border/50 bg-white/60 hover:border-secondary/30'
      }`}
    >
      <button type="button" className="flex w-full items-center justify-between gap-4 p-5 text-left md:p-6" onClick={onToggle}>
        <span className="flex items-center gap-4">
          <span className={`font-mono text-[11px] tabular-nums transition-colors ${isOpen ? 'text-secondary' : 'text-primary/25'}`}>
            {String(index + 1).padStart(2, '0')}
          </span>
          <span className={`font-cinzel text-base leading-snug transition-colors md:text-lg ${isOpen ? 'text-primary' : 'text-primary/70'}`}>
            {item.q}
          </span>
        </span>
        <span
          className={`grid h-8 w-8 shrink-0 place-items-center rounded-full transition-all duration-300 ${
            isOpen ? 'rotate-45 bg-primary text-white' : 'bg-primary/5 text-primary'
          }`}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4">
            <path d="M5 12h14" />
            <path d="M12 5v14" />
          </svg>
        </span>
      </button>
      <div
        className="grid transition-[grid-template-rows] duration-300 ease-out"
        style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
      >
        <div className="overflow-hidden">
          <div className="px-5 pb-5 pl-[3.5rem] text-sm leading-relaxed text-primary/60 md:px-6 md:pb-6 md:pl-[4.25rem]">
            {item.a}
          </div>
        </div>
      </div>
    </div>
  )
}
